import type { TrendItemContentTweetsItemBasicInfoAllOf } from './trendItemContentTweetsItemBasicInfoAllOf';
import type { TrendItemContentTweetsItemBasicInfoAllOfTwo } from './trendItemContentTweetsItemBasicInfoAllOfTwo';

export type TrendItemContentTweetsItemBasicInfo = TrendItemContentTweetsItemBasicInfoAllOf & TrendItemContentTweetsItemBasicInfoAllOfTwo;
